import { render, staticRenderFns } from "./queue.vue?vue&type=template&id=7c1ccb0f&scoped=true&"
import script from "./queue.vue?vue&type=script&lang=js&"
export * from "./queue.vue?vue&type=script&lang=js&"
import style0 from "./queue.vue?vue&type=style&index=0&id=7c1ccb0f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1ccb0f",
  null
  
)

export default component.exports